module.exports = __webpack_public_path__ + "img/open_white.810025ef.svg";